module.exports = __webpack_public_path__ + "img/close-icon.c2a6aae0.png";